(() => {
  const form=document.getElementById('gap-quote-form');if(!form)return;
  const track=(event)=>window.gapTrack?.(event);
  if(form.querySelector('.gap-form-success')){track('quote_submitted');return;}
  const steps=[...form.querySelectorAll('[data-step]')];if(!steps.length)return;
  const progress=[...form.querySelectorAll('.gap-quote-progress li')];
  const back=form.querySelector('[data-quote-back]'),next=form.querySelector('[data-quote-next]'),submit=form.querySelector('[data-quote-submit]'),error=form.querySelector('#quote-error');
  const upload=form.querySelector('#quote-drawings'),review=form.querySelector('#quote-review');
  const endpoint=form.dataset.apiUrl?.replace(/\/$/,''),siteKey=form.dataset.siteKey;
  let step=0,started=false,sending=false,requestId=crypto.randomUUID(),verificationToken='',widgetId=null;
  let verificationTimer;
  let verificationLoading=false;
  const retryVerification=document.createElement('button');
  retryVerification.type='button';retryVerification.className='gap-button gap-button-secondary';
  retryVerification.textContent='Retry verification';retryVerification.hidden=true;
  form.querySelector('#quote-verification')?.after(retryVerification);
  form.noValidate=true;
  const fail=(message)=>{error.textContent=message;error.hidden=false;};
  const value=id=>document.getElementById(`quote-${id}`)?.value||'';
  const display=id=>{const el=document.getElementById(`quote-${id}`);return el?.selectedOptions?el.selectedOptions[0]?.textContent:el?.value;};
  const updateReview=()=>{
    if(!review)return;review.hidden=false;
    const rows=[['Component',display('need')],['Part or system',value('part')],['Outside diameter',value('od')?`${value('od')} mm`:''],['Length',value('length')?`${value('length')} mm`:''],['Wall',value('wall')?`${value('wall')} mm`:''],['End finish',display('finish')],['Quantity',value('quantity')],['Timeline',display('timeline')],['Destination',value('destination')]];
    const dl=review.querySelector('dl');dl.replaceChildren();
    for(const [name,data] of rows){if(!data)continue;const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=name;dd.textContent=data;dl.append(dt,dd);}
  };
  const renderVerification=()=>{
    if(!endpoint||!siteKey||widgetId!==null||step!==3)return;
    if(!window.turnstile){loadVerification();return;}
    widgetId=window.turnstile.render('#quote-verification',{sitekey:siteKey,action:'quote',theme:'light',
      callback:token=>{verificationToken=token;error.hidden=true;retryVerification.hidden=true;clearTimeout(verificationTimer);},
      'expired-callback':()=>{verificationToken='';retryVerification.hidden=false;},
      'error-callback':()=>{verificationToken='';retryVerification.hidden=false;fail('Verification could not load. Retry verification below or call 714-898-8800.');}
    });
    clearTimeout(verificationTimer);
    verificationTimer=setTimeout(()=>{if(!verificationToken){retryVerification.hidden=false;fail('Verification is taking longer than expected. You can retry it without losing your details.');}},30000);
  };
  retryVerification.addEventListener('click',()=>{
    if(!window.turnstile){loadVerification();return;}
    clearTimeout(verificationTimer);if(widgetId!==null)window.turnstile.remove(widgetId);
    widgetId=null;verificationToken='';retryVerification.hidden=true;error.hidden=true;renderVerification();
  });
  const show=(focus=true)=>{
    steps.forEach((s,i)=>s.hidden=i!==step);
    progress.forEach((s,i)=>{if(i===step)s.setAttribute('aria-current','step');else s.removeAttribute('aria-current');});
    back.hidden=step===0;next.hidden=step===steps.length-1;submit.hidden=step!==steps.length-1;
    if(step===3){updateReview();renderVerification();}
    if(focus){const legend=steps[step].querySelector('legend');legend.tabIndex=-1;legend.focus();}
  };
  const checkFiles=()=>{
    if(!upload)return true;upload.setCustomValidity('');
    const files=[...upload.files];
    if(files.length>5)upload.setCustomValidity('Upload up to 5 drawings.');
    else if(files.reduce((n,f)=>n+f.size,0)>25*1024*1024)upload.setCustomValidity('Drawings must total 25 MB or less.');
    else if(files.some(f=>!f.size||!(/\.(pdf|png|jpe?g|dwg|step|stp)$/i.test(f.name))))upload.setCustomValidity('Choose a non-empty PDF, PNG, JPG, DWG, or STEP file.');
    return upload.checkValidity();
  };
  const validate=fieldset=>{
    const od=form.querySelector('#quote-od'),wall=form.querySelector('#quote-wall');wall.setCustomValidity('');
    if(od.value&&wall.value&&Number(wall.value)*2>=Number(od.value))wall.setCustomValidity('Wall thickness must be less than half the outside diameter.');
    checkFiles();
    for(const el of fieldset.querySelectorAll('input,select,textarea'))if(!el.checkValidity()){el.reportValidity();return false;}
    return true;
  };
  const begin=()=>{if(!started){track('quote_started');started=true;}};
  next.addEventListener('click',()=>{if(sending||!validate(steps[step]))return;begin();step++;error.hidden=true;show();});
  back.addEventListener('click',()=>{if(sending)return;step=Math.max(0,step-1);error.hidden=true;show();});
  form.addEventListener('input',()=>{begin();if(!sending)requestId=crypto.randomUUID();});
  upload?.addEventListener('change',()=>{
    requestId=crypto.randomUUID();checkFiles();
    const list=form.querySelector('#quote-file-list');list.replaceChildren();
    for(const file of upload.files){const item=document.createElement('li');item.textContent=`${file.name} · ${(file.size/1024/1024).toFixed(2)} MB`;list.append(item);}
    if(!upload.checkValidity())upload.reportValidity();
  });
  const transport=()=>{
    const data=new FormData();data.set('request_id',requestId);
    for(const key of ['need','part','od','length','wall','finish','description','quantity','timeline','destination','name','company','email','phone','application','audience','website'])data.set(key,value(key));
    for(const file of upload?.files||[])data.append('drawings',file);
    data.set('cf-turnstile-response',verificationToken);
    try{const campaign=JSON.parse(value('campaign')||'{}');for(const k of ['utm_source','utm_medium','utm_campaign','utm_term','utm_content'])if(campaign[k])data.set(k,String(campaign[k]).slice(0,500));}catch(_){}
    return data;
  };
  const success=reference=>{
    const box=document.createElement('div');box.className='gap-form-success';box.setAttribute('role','status');box.tabIndex=-1;
    const h=document.createElement('h2');h.textContent='Got it.';
    const message=document.createElement('p');message.textContent='Expect to hear from us within one business day.';
    const ref=document.createElement('p');ref.className='gap-mono';ref.textContent=`Request ${reference}`;
    const note=document.createElement('p');note.textContent='Your request and drawings have been saved. A confirmation email will follow.';
    const link=document.createElement('a');link.className='gap-text-link';link.href='/collections/all';link.textContent='Browse replacement parts ↗';
    box.append(h,message,ref,note,link);form.replaceChildren(box);box.focus();track('quote_submitted');
  };
  form.addEventListener('submit',async event=>{
    if(sending){event.preventDefault();return;}
    if(step<steps.length-1){event.preventDefault();next.click();return;}
    for(let i=0;i<steps.length;i++){
      steps[i].hidden=false;
      if(!validate(steps[i])){event.preventDefault();step=i;show(false);steps[i].querySelector(':invalid')?.reportValidity();return;}
      steps[i].hidden=i!==step;
    }
    begin();
    if(!endpoint){submit.disabled=true;submit.textContent='Sending your request…';return;}
    event.preventDefault();
    if(!verificationToken){renderVerification();retryVerification.hidden=false;fail('Please complete the verification before sending your request.');return;}
    sending=true;submit.disabled=true;back.disabled=true;error.hidden=true;submit.textContent='Saving your request…';
    const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),120000);
    try{
      const response=await fetch(`${endpoint}/quotes`,{method:'POST',body:transport(),signal:controller.signal,credentials:'omit'});
      const result=await response.json();
      if(!response.ok||!result.ok||!result.reference)throw new Error(result.error||'Your request could not be saved. Please try again.');
      success(result.reference);
    }catch(problem){
      fail(problem.name==='AbortError'?'The connection timed out. Your details are still here. Try sending again; duplicate requests will be recognized.':problem.message||'Connection failed. Please try again.');
      sending=false;submit.disabled=false;back.disabled=false;submit.textContent='Send my request ↗';verificationToken='';
      if(widgetId!==null)window.turnstile?.reset(widgetId);
    }finally{clearTimeout(timeout);}
  });
  const params=new URLSearchParams(location.search);
  for(const key of ['need','od','length','wall','quantity','finish','part','application','audience','destination']){
    if(!params.has(key))continue;const el=document.getElementById(`quote-${key}`);if(!el)continue;let incoming=params.get(key).slice(0,200);
    if(key==='need')incoming=({'UV lamp':'lamp-ballast','Quartz sleeve':'sleeve'})[incoming]||incoming;
    if(el.tagName==='SELECT'){if([...el.options].some(o=>o.value===incoming))el.value=incoming;}else el.value=incoming;
  }
  try{document.getElementById('quote-campaign').value=sessionStorage.getItem('gap-utm')||'';}catch(_){}
  function loadVerification(){
    if(!endpoint||!siteKey||verificationLoading)return;
    verificationLoading=true;
    window.gapTurnstileReady=renderVerification;
    const script=document.createElement('script');script.src='https://challenges.cloudflare.com/turnstile/v0/api.js?onload=gapTurnstileReady&render=explicit';script.async=true;script.defer=true;
    script.addEventListener('error',()=>{clearTimeout(verificationTimer);verificationLoading=false;retryVerification.hidden=false;fail('Verification could not load. Retry below or email sales@glassautomated.com.');});document.head.append(script);
    verificationTimer=setTimeout(()=>{if(!window.turnstile){verificationLoading=false;script.remove();retryVerification.hidden=false;fail('Verification is taking longer than expected. Retry below; your details are still here.');}},30000);
  }
  show(false);
})();
